import { Injectable } from '@angular/core';
import { isNil, Nillable } from '@web/utils';
import { ToastSeverity } from '../types/toast-severity';
import { Toast } from '../models/toast';
import { RequiredMethodCallException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class ToastBuilder {
  private _severity: Nillable<ToastSeverity>;
  private _message: Nillable<string>;
  private _title: Nillable<string>;
  private _immortal: Nillable<boolean>;
  private _life: Nillable<number>;

  public constructor() {
    this.reset();
  }

  public initSuccess(message: string): this {
    return this.message(message).title('Sukces').severity('success');
  }

  public initWarning(message: string): this {
    return this.message(message).title('Uwaga').severity('warning');
  }

  public initError(message: string): this {
    return this.message(message).title('Błąd').severity('error');
  }

  public initInfo(message: string): this {
    return this.message(message).title('Informacja').severity('info');
  }

  public severity(severity: ToastSeverity): this {
    this._severity = severity;

    return this;
  }

  public message(message: string): this {
    this._message = message;

    return this;
  }

  public title(title: string): this {
    this._title = title;

    return this;
  }

  public immortal(): this {
    this._immortal = true;

    return this;
  }

  public life(life: number): this {
    this._life = life;

    return this;
  }

  public reset(): this {
    this._severity = null;
    this._message = null;
    this._title = null;
    this._immortal = null;
    this._life = null;

    return this;
  }

  public build(): Toast {
    this.requireTitle();
    this.requireMessage();
    this.requireSeverity();

    this.configureDefaultImmortality();
    this.configureDefaultLife();

    const toast = new Toast(
      this._title!,
      this._message!,
      this._severity!,
      this._immortal!,
      this._life!,
    );

    this.reset();

    return toast;
  }

  private requireMessage(): void {
    if (isNil(this._message)) {
      throw new RequiredMethodCallException(this.message.name);
    }
  }

  private requireTitle(): void {
    if (isNil(this._title)) {
      throw new RequiredMethodCallException(this.title.name);
    }
  }

  private requireSeverity(): void {
    if (isNil(this._severity)) {
      throw new RequiredMethodCallException(this.severity.name);
    }
  }

  private configureDefaultImmortality(): void {
    if (isNil(this._immortal)) {
      this._immortal = false;
    }
  }

  private configureDefaultLife(): void {
    if (isNil(this._life)) {
      this.life(5000);
    }
  }
}
